import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// import example from './example'

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/home'),
      redirect: '/main',
      children: [
        {
          path: '/main',
          name: 'Main',
          component: () => import('../views/main')
        },
        {
          path: '/policy',
          name: 'Policy',
          component: () => import('../views/policy')
        },
        {
          path: '/quotation',
          name: 'Quotation',
          component: () => import('../views/quotation')
        },
        {
          path: '/application',
          name: 'Application',
          component: () => import('../views/application')
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/login')
    },
  ]
})

router.beforeEach((to, from, next) => {
  const { path, fullPath } = to
  const token = localStorage.getItem('token')
  if(path !== '/login' && !token) {
    next({ path: `/login?fullPath=${fullPath}` })
  } else {
    next()
  }
})

//  滚动条置顶
router.afterEach(() => {
  let scrollContent = document.getElementById('scroll-content')
  if(scrollContent) {
    scrollContent.scrollTop = 0
  }
})

export default router